import { atom } from "jotai";

export const isKeyboardShortcutsModalOpenAtom = atom(false);

isKeyboardShortcutsModalOpenAtom.debugLabel =
  "isKeyboardShortcutsModalOpenAtom";
